<template>
  <div data-scroll-container>
    <div data-scroll-section>
      <div
        class="row justify-content-center align-items-center h-100 mt-lg-0 mt-md-5 mt-sm-0 mt-6 mb-12 pb-xxl-17 pb-lg-14"
      >
        <div class="col-xxl-13 col-sm-15">
          <div class="text-sm-right">
            <!-- ls-30 -->
            <a
              href="tel:+306948096537"
              class="xxsmall font-weight-normal link-strikethrough d-sm-inline-block d-block"
              >+30 694 809 6537</a
            >
            <a
              href="mailto:info@nickyeconomou.com"
              class="xxsmall font-weight-normal link-strikethrough ml-lg-12 ml-sm-6 d-sm-inline-block d-block"
              >info@nickyeconomou.com</a
            >
          </div>

          <h1 class="title-2 mt-xl-0 mt-md-10 mt-sm-6 mt-6">work with me</h1>

          <form
            @submit.prevent="submit()"
            action=""
            method="POST"
            class="mt-3"
            v-if="!contactForm.sent"
          >
            <div class="row align-items-center">
              <div class="col-xl-8 mb-sm-5">
                <div id="reason" class="radio-wrapper">
                  <div
                    class="radio-button mr-sm-5 mb-sm-0 mb-3"
                    :class="{ 'has-error': $v.contactForm.reason.$error }"
                  >
                    <label for="wedding"
                      >wedding
                      <input
                        id="wedding"
                        type="radio"
                        v-model="$v.contactForm.reason.$model"
                        value="wedding"
                      />
                      <span class="radio"></span>
                    </label>
                  </div>

                  <div
                    class="radio-button mr-sm-5 mb-sm-0 mb-3"
                    :class="{ 'has-error': $v.contactForm.reason.$error }"
                  >
                    <label for="christening"
                      >christening
                      <input
                        id="christening"
                        type="radio"
                        v-model="$v.contactForm.reason.$model"
                        value="christening"
                      />
                      <span class="radio"></span>
                    </label>
                  </div>

                  <div
                    class="radio-button mr-sm-5 mb-sm-0 mb-3"
                    :class="{ 'has-error': $v.contactForm.reason.$error }"
                  >
                    <label for="corporate"
                      >corporate
                      <input
                        id="corporate"
                        type="radio"
                        v-model="$v.contactForm.reason.$model"
                        value="corporate"
                      />
                      <span class="radio"></span>
                    </label>
                  </div>

                  <div
                    class="radio-button mr-sm-3 mb-sm-0 mb-3"
                    :class="{ 'has-error': $v.contactForm.reason.$error }"
                  >
                    <label for="other"
                      >other
                      <input
                        id="other"
                        type="radio"
                        v-model="$v.contactForm.reason.$model"
                        value="other"
                      />
                      <span class="radio"></span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-5 col-sm-8">
                <div
                  class="input-wrapper label-float"
                  :class="{
                    'has-error': $v.contactForm.when.$error,
                    'has-value': $v.contactForm.when.$model,
                  }"
                >
                  <p
                    v-cloak
                    v-if="$v.contactForm.when.$error"
                    class="error-msg"
                  >
                    PLEASE FILL THIS
                  </p>
                  <label for="when">when</label>
                  <input
                    v-datepicker-in-fullscreen="{
                      format: 'ddd DD MMM, YYYY',
                    }"
                    readonly
                    id="when"
                    type="text"
                    v-model="$v.contactForm.when.$model"
                  />
                </div>
              </div>

              <div class="col-lg-5 col-sm-8">
                <div
                  class="input-wrapper label-float"
                  :class="{
                    'has-error': $v.contactForm.where.$error,
                    'has-value': $v.contactForm.where.$model,
                  }"
                >
                  <p
                    v-cloak
                    v-if="$v.contactForm.where.$error"
                    class="error-msg"
                  >
                    PLEASE FILL THIS
                  </p>
                  <label for="where">where <span>(city, country)</span></label>
                  <input
                    id="where"
                    type="text"
                    v-model="$v.contactForm.where.$model"
                  />
                </div>
              </div>

              <div class="col-xl-16 col-lg-6 col-16">
                <div
                  class="input-wrapper label-float"
                  :class="{
                    'has-error': $v.contactForm.name.$error,
                    'has-value': $v.contactForm.name.$model,
                  }"
                >
                  <p
                    v-cloak
                    v-if="$v.contactForm.name.$error"
                    class="error-msg"
                  >
                    PLEASE FILL THIS
                  </p>
                  <label for="name">name</label>
                  <input
                    id="name"
                    type="text"
                    v-model="$v.contactForm.name.$model"
                  />
                </div>
              </div>

              <div class="col-md-8">
                <div
                  class="input-wrapper label-float"
                  :class="{
                    'has-error': $v.contactForm.email.$error,
                    'has-value': $v.contactForm.email.$model,
                  }"
                >
                  <p
                    v-cloak
                    v-if="
                      $v.contactForm.email.$error &&
                      !$v.contactForm.email.required
                    "
                    class="error-msg"
                  >
                    PLEASE FILL THIS
                  </p>
                  <p
                    v-cloak
                    v-if="
                      $v.contactForm.email.$error && !$v.contactForm.email.email
                    "
                    class="error-msg"
                  >
                    FILL AN EMAIL
                  </p>
                  <label for="email">email</label>
                  <input
                    id="email"
                    type="text"
                    v-model="$v.contactForm.email.$model"
                  />
                </div>
              </div>

              <div class="col-md-8">
                <div
                  class="input-wrapper label-float"
                  :class="{
                    'has-error': $v.contactForm.phone.$error,
                    'has-value': $v.contactForm.phone.$model,
                  }"
                >
                  <p
                    v-cloak
                    v-if="$v.contactForm.phone.$error"
                    class="error-msg"
                  >
                    PLEASE FILL THIS
                  </p>
                  <label for="phone">tel</label>
                  <input
                    id="phone"
                    type="text"
                    v-model="$v.contactForm.phone.$model"
                  />
                </div>
              </div>

              <div class="col-16 mt-2">
                <div
                  class="textarea-wrapper label-float"
                  :class="{
                    'has-error': $v.contactForm.message.$error,
                    'has-value': $v.contactForm.message.$model,
                  }"
                >
                  <p
                    v-cloak
                    v-if="
                      $v.contactForm.message.$error &&
                      !$v.contactForm.message.required
                    "
                    class="error-msg"
                  >
                    PLEASE FILL THIS
                  </p>
                  <p
                    v-cloak
                    v-if="
                      $v.contactForm.message.$error &&
                      !$v.contactForm.message.maxLength
                    "
                    class="error-msg"
                  >
                    MAX @{{ $v.contactForm.message.$params.maxLength.max }}
                    CHARACTERS
                  </p>
                  <label for="message">additional message</label>
                  <textarea
                    id="message"
                    v-model="$v.contactForm.message.$model"
                    cols="30"
                    rows="7"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-16 text-right">
                <button
                  type="submit"
                  class="btn-submit"
                  :class="{ loading: contactForm.sending }"
                >
                  <span class="background"></span>
                  <span><i class="icon-arrow-tail-right"></i></span>
                  <span class="loader"></span>
                </button>
              </div>
            </div>
          </form>

          <div v-else class="row pt-10">
            <div
              class="col-xxl-9 col-xl-12 col-lg-14 d-flex flex-sm-row flex-column align-items-center justify-content-start"
            >
              <img
                src="/site/nickyeconomou/dist/images/success.png"
                alt="success"
                class="img-150 mr-sm-8"
              />

              <div class="mt-sm-0 mt-6">
                <p class="h3 ls-10 lh-12 mb-3">Thank you for your message.</p>
                <p class="xxsmall ls-10 lh-15 mb-2">
                  I am excited to connect with you and discuss your photography
                  needs further. I will review your message and get back to you
                  within 24-48 hours.
                </p>

                <p class="xxsmall lh-sm-20 lh-15 mb-6">
                  In the meantime, feel free to browse my portfolio. <br />
                  I look forward to the opportunity to capture your special
                  moments.
                </p>
                <button type="button" class="btn-lines" @click="clearForm()">
                  <span class="background"></span>
                  <span class="btn-text">CLOSE</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import DatepickerInFullscreen from "../directives/datepicker-in-fullscreen/index.js";

import axios from "axios";
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-TOKEN": window.Laravel.csrfToken,
};

import { email, required, maxLength } from "vuelidate/lib/validators";

export default {
  directives: {
    DatepickerInFullscreen,
  },
  data() {
    return {
      contactForm: {
        reason: null,
        when: null,
        where: null,
        name: null,
        email: null,
        phone: null,
        message: null,
        sent: false,
        sending: false,
      },
    };
  },
  validations() {
    let validations = {
      contactForm: {
        reason: {
          required,
        },
        when: {
          required,
        },
        where: {
          required,
        },
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        phone: {
          required,
        },
        message: {
          maxLength: maxLength(500),
        },
      },
    };

    return validations;
  },
  methods: {
    submit() {
      const component = this;

      component.$v.contactForm.$touch();

      if (component.$v.contactForm.$invalid) {
        let invalidField;

        Object.keys(component.$v.contactForm.$params).some(function (item) {
          invalidField = Object.keys(component.$v.contactForm).find(
            (key) => component.$v.contactForm[key].$invalid
          );
          return invalidField;
        });

        component.$scrollTo(document.getElementById(invalidField), 1000, {
          offset: -150,
        });
      } else {
        component.contactForm.sending = true;
        component.contactForm.error = false;

        axios
          .post(window.Laravel.uris.contact, component.contactForm)
          .then(function (response) {
            var _data = response.data;
            component.contactForm.sending = false;
            component.contactForm.sent = true;
          })
          .catch(function (error) {
            var _data = error.response.data;
            // component.contactForm.error_message = _data.errors.email[0];
            component.contactForm.error = true;
            component.contactForm.sending = false;
            component.contactForm.sent = false;
          });
      }
    },
    clearForm() {
      this.contactForm.sent = false;
      this.contactForm.reason = "wedding";
      this.contactForm.when = null;
      this.contactForm.where = null;
      this.contactForm.name = null;
      this.contactForm.email = null;
      this.contactForm.phone = null;
      this.contactForm.message = null;
      this.$v.contactForm.$reset();
    },
  },
  mounted() {
    this.$root.setLoaderPercentage(100);

    setTimeout(() => {
      this.$store.dispatch("togglePageReady", true);
    }, this.$root.loaderCountDuration - 2000);
  },
};
</script>

<style lang="scss">
@import "src/sass/variables";
@import "src/sass/mixins";
@import "node_modules/bootstrap/scss/vendor/rfs";
</style>